import React, {useContext, useEffect, useState} from 'react';
import {PointLayerContext} from "../point-layer-context.jsx";

const PointsList = ({setShowPointPanel, setPointSelected, cacheList}) => {
    const {points} = useContext(PointLayerContext)

    const [pointsFiltered, setPointsFiltered] = useState([])

    const openPoint = (point) => {
        setPointSelected(point)
        setShowPointPanel(true)
    }

    useEffect(() => {
        if (cacheList) {
            setPointsFiltered(points.filter(p => typeof p.id  === 'string'))
        } else {
            setPointsFiltered(points.filter(p => p.data.name))
        }
    }, [points]);

    return (
        <>
            {
                pointsFiltered.map((p, index) => {
                    return(
                        <div key={index} onClick={() => openPoint(p)} className={"mt-1 border border-[#e5e7eb] rounded-md flex justify-between px-2.5 h-8 cursor-pointer hover:bg-[#e7eaec]"}>
                            <div className={"flex items-center text-[13px] font-bold text-[#063A6C]"} title={p.data.name}>
                                {!p.data.name && <span className={`italic`}>Ponto sem nome</span>}
                                {p.data.name && <span className={"truncate w-50"}>{p.data.name}</span>}
                            </div>
                        </div>
                    )
                })
            }
        </>
    );
};

export default PointsList;